import { Product } from '../data/terra/Product';
import { Project } from '../data/terra/Project';

export const mapProjectToProduct = (project: Project): Product => {
  return {
    code: project.projectCode,
    name: project.projectName,
    createdAt: project.createdAt,
    id: project.projectId,
    logo: project.logoUrl,
    updatedAt: project.updatedAt,
  };
};